import { z, isoZ } from 'my-zod'

export const vehicleDispositionStatusEnum = z.enum([
  'Unknown',
  // Used when outfitter indicates they have completed the disposition form and is ready for review
  'ReadyForReview',
  // Used when account manager has approved the disposition
  'Approved',
  // Used for both the initial state *and* after rejections by the account manager
  'AwaitingDispositionForm',
  // The vehicle is now inactive and awaiting pickup.  See entities/vehicle-disposition.ts
  'Pending',
  // The vehicle is disposed.  See entities/vehicle-disposition.ts
  'Complete'
])
export const DispositionStatuses = vehicleDispositionStatusEnum.Values
export type DispositionStatus = z.infer<typeof vehicleDispositionStatusEnum>

export const vehicleDispositionsModel = z
  .object({
    id: z.string().uuid(),
    createdDate: isoZ.instant().nullable(),
    lastModifiedDate: isoZ.instant().nullable(),
    deletedDate: isoZ.instant().nullable(),
    vehicleId: z.number().nullable(),
    operatorId: z.number().nullable(),
    engineHours: z.number().nullable(),
    mileage: z.number().nullable(),
    notes: z.string().nullable(),
    damageDescription: z.string().nullable(),
    vehicleConditionScore: z.number().int().min(1).max(10).nullable(),
    vehicleImageRight: z.string().array().nullable(),
    vehicleImageLeft: z.string().array().nullable(),
    vehicleImageFront: z.string().array().nullable(),
    vehicleImageBack: z.string().array().nullable(),
    additionalVehicleImages: z.string().array().nullable(),
    reviewNotes: z.string().nullable(),
    status: vehicleDispositionStatusEnum.nullable(),
    serverLastModifiedDate: isoZ.instant().nullable()
  })
  .setCFV({
    engineHoursRequired(val) {
      if (!val.engineHours && val.engineHours !== 0) {
        return {
          message: 'Please provide Engine Hours.',
          path: ['engineHours']
        }
      }
    },
    mileageRequired(val) {
      if (!val.mileage && val.mileage !== 0) {
        return {
          message: 'Please provide Mileage.',
          path: ['mileage']
        }
      }
    }
  })

export type vehicleDispositionsModel = z.infer<typeof vehicleDispositionsModel>
